import React, { Component, Fragment } from 'react';
import { Modal, Button, ListGroup } from 'react-bootstrap';
import config from '../../config';

class Example extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      noticias: []
    }
  }

  componentDidMount() {
    fetch(config.servBackEnd + '/notice/listnotice')
      .then(res1 => res1.json())
      .then((data1) => {
        ////console.log(data1.data)
        const noticias = (data1.ok) ? data1.data: [];
        this.setState({
          noticias
        })
      })
      .catch((error) => console.error(error))
  }

  validarEnter = (e) => {
    const func = this.props.irHome;
    if (e.keyCode === 13){
      
      func();
    }
}


  render() {
    const { show } = this.props;
    const func = this.props.irHome;
    const { noticias } = this.state;
    ////console.log(data);
    return (
      <Fragment>
        <div onKeyUp={this.validarEnter}>
        <Modal
          show={show}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>Noticias </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              noticias.map((noticia, i) => {
                return  (<div key={i}>
                  <ListGroup>
                    <ListGroup.Item as="li" active >{noticia.TITULO_NOTICIA}</ListGroup.Item>
                    <ListGroup.Item variant="light" >{noticia.DESCRIPCION_NOTICIA}</ListGroup.Item> <br />
                  </ListGroup>
                </div>);
              })
            }
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={func} variant="secondary">Aceptar</Button>
          </Modal.Footer>
        </Modal>
        </div>
      </Fragment>
    );
  }
}

export default Example;